import {
  AbstractControl,
  AsyncValidatorFn,
  UntypedFormGroup,
  ValidatorFn,
} from '@angular/forms';
import {
  debounceTime,
  distinctUntilChanged,
  first,
  map,
  switchMap,
} from 'rxjs/operators';

import { luhnCheck } from '../helpers/luhn.helper';
import { PasswordService } from '../services/password/password.service';

export function luhnValidator(): ValidatorFn {
  return (control: AbstractControl) => {
    const isValid = luhnCheck(control.value as string);

    return isValid ? null : { luhnCheck: isValid };
  };
}

export function passwordConfirmationValidator(
  passwordFieldName,
  passwordConfirmationFieldName,
): ValidatorFn {
  return (group: UntypedFormGroup) => {
    const original_password = group.get(passwordFieldName);
    const confirm_password = group.get(passwordConfirmationFieldName);

    if (confirm_password?.errors && !confirm_password.errors.sameAsOriginal) {
      // DO NOTHING
    } else {
      if (original_password?.value === confirm_password?.value) {
        confirm_password?.setErrors(null);
      } else {
        confirm_password?.setErrors({ sameAsOriginal: true });
      }
    }

    return null;
  };
}

export function asyncPasswordValidator(
  passwordService: PasswordService,
): AsyncValidatorFn {
  return (control) => {
    return control.valueChanges.pipe(
      debounceTime(400),
      distinctUntilChanged(),
      switchMap(() => {
        return passwordService.getPasswordValidatorsAndText();
      }),
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      map((result: any) => {
        const regex = new RegExp(result.config.regex as RegExp);
        const condition = regex.test(control.value as string);
        return condition ? null : { passwordRequirments: result.text };
      }),
      first(),
    );
  };
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function uniqueValueValidator(valuesToCheck: any[]): ValidatorFn {
  return (control: AbstractControl) => {
    const { value } = control;
    const isUnique = !valuesToCheck.some((x) => {
      return x == value;
    });

    return isUnique ? null : { uniqueValue: value };
  };
}
